export const POSTING = 'posting';
export const EDITION = 'edition';
export const REPUBLISH = 'republish';
export const ROUTE_CONSTANTS = {
    ATTRIBUTES: 'attributes',
    VERIFY_ACCOUNT: 'verifyaccount'
};

export const PARAM_KEYS = {
    REGULATION_KEY: 'regulationKey',
    YEAR: 'year'
};
export const REGULATION_INFORMATION_TEXT = 'regulation_information_text';
export const CAR_DEALER_CONSENT = 'carDealerConsent';
